import React, { Component } from 'react'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'
import Slider from './Slider'
import './vision.css'

export default class Vision extends Component {
  render() {
    return (
      <Row className='vision'>
        <Col md={6} sm={12}>
          <h2 style={{ fontSize: "xxx-large", fontWeight: "800", color: " #fecd32" }}>Who Are We?</h2>
          <p> Seven Egyptian stand-up comedians</p>
          <p >We offer you a good laughter and a happy time.</p>
          <p>We are loaded with jokes and quotes that will kill </p>
          <p >your past sadness and shape your future happiness</p>
        </Col>
        {/* <Col className="right-side">
          <p>We are loaded with jokes and quotes that will kill </p>
          <p id="before-button">your past sadness and shape your future happiness</p>
          <a className='go-to-events' href='/gallery'>Go to Our Gallery</a>

        </Col> */}
        <Col className="right-side">
          {/* <p>We are loaded with jokes and quotes that will kill </p>
          <p id="before-button">your past sadness and shape your future happiness</p> */}
          <Slider/>
          <a className='go-to-events' href='/gallery'>Go to Our Gallery</a>

        </Col>

      </Row>
    )
  }
}
